export default __webpack_public_path__ + "static/media/pic5.68e074af.jpg";